import { Trigger } from "./components/trigger";
import { Container } from "./components/container";
import { Content } from "./components/content";

/**
 * Objeto que exporta los componentes que tiene la base de un elemento que se expande y contrae ej: combobox, select, dropdown, etc
 */
export const Expandable = {
	Container,
	Trigger,
	Content,
};
